import {
  Box,
  colors,
  SxProps,
  Theme,
  Tooltip,
  Typography
} from "@mui/material";

export function SummaryBox({
  sx,
  count,
  tooltip,
}: {
  count: number;
  sx?: SxProps<Theme>;
  tooltip?: string;
}) {
  return (
    <Tooltip arrow title={tooltip}>
      <Box
        sx={[
          {
            color: colors.grey[400],
            width: 23,
            textAlign: "center",
            cursor: "default",
            backgroundColor: colors.grey[100],
            borderRadius: 1,
          },
          (theme) =>
            theme.applyStyles("dark", {
              backgroundColor: "background.paper",
              color: colors.grey[400],
            }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Typography fontWeight={700}>{count}</Typography>
      </Box>
    </Tooltip>
  );
}
